export default {
  PDF: 'application/pdf',
};
